<template>
	<modal
		:modal-id="modalId"
		:title="modalTitle"
		:preloader="preloader"
		@submit="submit"
		@close-modal="closeModal"
	>
		<template slot="body">
			<app-overlay-loader v-if="preloader" />
			<form
				class="mb-0"
				:class="{ 'loading-opacity': preloader }"
				ref="form"
				:data-url="
					selectedUrl
						? `master/village/${inputs.id}`
						: `master/village`
				"
			>
				<div class="form-group row align-items-center">
					<label for="inputs_country" class="col-sm-3 mb-0">
						{{ $t("country") }}
					</label>
					<app-input
						id="inputs_country"
						class="col-sm-9"
						type="advance-search-select"
						:loaded-per-time="10"
						v-model="input_country"
						@input="setCountryValue"
						fetch-url="master/country"
						:placeholder="$t('country')"
						list-value-field="name"
						:required="true"
					/>
				</div>

				<div class="form-group row align-items-center">
					<label for="inputs_province" class="col-sm-3 mb-0">
						{{ $t("province") }}
					</label>
					<app-input
						id="inputs_province"
						class="col-sm-9"
						type="advance-search-select"
						:loaded-per-time="10"
						v-model="input_province"
						@input="setProvinceValue"
						:fetch-url="`master/province?country_id=${input_country.id}`"
						:placeholder="$t('province')"
						list-value-field="name"
						:required="true"
					/>
				</div>

				<div class="form-group row align-items-center">
					<label for="inputs_city" class="col-sm-3 mb-0">
						{{ $t("city") }}
					</label>
					<app-input
						id="inputs_city"
						class="col-sm-9"
						type="advance-search-select"
						:loaded-per-time="10"
						v-model="input_city"
						@input="setCityValue"
						:fetch-url="`master/city?province_id=${input_province.id}&country_id=${input_country.id}`"
						:placeholder="$t('city')"
						list-value-field="name"
						:required="true"
					/>
				</div>

				<div class="form-group row align-items-center">
					<label for="inputs_district" class="col-sm-3 mb-0">
						{{ $t("district") }}
					</label>
					<app-input
						id="inputs_district"
						class="col-sm-9"
						type="advance-search-select"
						:loaded-per-time="10"
						v-model="input_district"
						@input="setParentValue"
						:fetch-url="`master/district?district_id=${input_district.id}&province_id=${input_province.id}&country_id=${input_country.id}`"
						:placeholder="$t('district')"
						list-value-field="name"
						:required="true"
					/>
				</div>

				<div class="form-group row align-items-center">
					<label for="inputs_code" class="col-sm-3 mb-0">
						{{ $t("code") }}
					</label>
					<app-input
						id="inputs_code"
						class="col-sm-9"
						type="text"
						v-model="inputs.code"
						:placeholder="$t('code')"
					/>
				</div>

				<div class="form-group row align-items-center">
					<label for="inputs_name" class="col-sm-3 mb-0">
						{{ $t("name") }}
					</label>
					<app-input
						id="inputs_name"
						class="col-sm-9"
						type="text"
						v-model="inputs.name"
						:placeholder="$t('name')"
						:required="true"
					/>
				</div>

				<div class="form-group row align-items-center">
					<label for="inputs_postal_code" class="col-sm-3 mb-0">
						{{ $t("postal_code") }}
					</label>
					<app-input
						id="inputs_postal_code"
						class="col-sm-9"
						type="text"
						v-model="inputs.postal_code"
						:placeholder="$t('postal_code')"
						:required="true"
					/>
				</div>

				<div class="form-group row align-items-center">
					<label for="inputs_is_active" class="col-sm-3 mb-0">
						&nbsp;
					</label>
					<div class="col-sm-8">
						<app-input
							id="inputs_is_active"
							:list-value-field="$t('is_active')"
							type="single-checkbox"
							v-model="inputs.is_active"
						/>
					</div>
				</div>
				<!-- <div class="form-group row align-items-center">
                    <label for="inputs_email" class="col-sm-3 mb-0">
                        {{ $t('email') }}
                    </label>
                    <app-input id="inputs_email"
                               class="col-sm-9"
                               type="email"
                               v-model="inputs.email"
                               :placeholder="$t('email_type_input')"
                               :required="true"/>
                </div>
                <div class="form-group row align-items-center">
                    <label for="inputs_phone" class="col-sm-3 mb-0">
                        {{ $t('contact_number') }}
                    </label>
                    <app-input id="inputs_phone"
                               class="col-sm-9"
                               type="tel-input"
                               v-model="phone"
                               :placeholder="$t('type_contact_number')"/>
                </div>
                <div class="form-group row align-items-center">
                    <label for="inputs_status" class="col-sm-3 mb-0">
                        {{ $t('status') }}
                    </label>
                    <app-input id="inputs_status"
                               class="col-sm-9"
                               type="select"
                               :required="true"
                               v-model="inputs.status"
                               :list="statusLists"/>
                </div>
                <div class="form-group row align-items-center">
                    <label for="inputs_age" class="col-sm-3 mb-0">
                        {{ $t('age') }}
                    </label>
                    <app-input id="inputs_age"
                               class="col-sm-9"
                               type="number"
                               :max-number="100"
                               v-model="inputs.age"
                               :placeholder="$t('type_age')"/>
                </div>
                <div class="form-group row align-items-center mb-0">
                    <label class="col-sm-3 mb-0">
                        {{ $t('gender') }}
                    </label>
                    <app-input class="col-sm-9"
                               type="radio"
                               v-model="inputs.gender"
                               :list="genderLists"/> -->
				<!-- </div> -->
			</form>
		</template>
	</modal>
</template>

<script>
import { FormMixin } from "../../../../../core/mixins/form/FormMixin.js";
import { ModalMixin } from "../../../../Mixins/ModalMixin";

export default {
	name: "ModalForm",
	mixins: [FormMixin, ModalMixin],
	props: {
		tableId: String,
		formId: String,
		value: {
			type: Object,
			default: () => {
				return {
					province_id: undefined,
					code: "",
					name: "",
					is_active: "",
					province: {
						id: undefined,
						code: "",
						name: "",
						is_active: "",
					},
				};
			},
		},
	},
	data() {
		return {
			preloader: false,
			input_district: this.value
				? this.value.district
					? {
							id: this.value.district.id || 0,
							name: this.value.district.name || "",
							code: this.value.district.code,
							is_active: this.value.district.is_active,
					  }
					: {
							id: this.value.district?.id || 0,
							name: this.value.district?.name || "",
							code: this.value.district?.code,
							is_active: this.value.district?.is_active,
					  }
				: {
						id: this.value.district.id || 0,
						name: this.value.district.name || "",
						code: this.value.district.code,
						is_active: this.value.district.is_active,
				  },
			input_city: this.value
				? this.value.city
					? {
							id: this.value.city.id || 0,
							name: this.value.city.name || "",
							code: this.value.city.code,
							is_active: this.value.city.is_active,
					  }
					: {
							id: this.value.city?.id || 0,
							name: this.value.city?.name || "",
							code: this.value.city?.code,
							is_active: this.value.city?.is_active,
					  }
				: {
						id: this.value.city.id || 0,
						name: this.value.city.name || "",
						code: this.value.city.code,
						is_active: this.value.city.is_active,
				  },
			input_province: this.value
				? this.value.province
					? {
							id: this.value.province.id || 0,
							name: this.value.province.name || "",
							code: this.value.province.code,
							is_active: this.value.province.is_active,
					  }
					: {
							id: this.value.province?.id || 0,
							name: this.value.province?.name || "",
							code: this.value.province?.code,
							is_active: this.value.province?.is_active,
					  }
				: {
						id: this.value.province.id || 0,
						name: this.value.province.name || "",
						code: this.value.province.code,
						is_active: this.value.province.is_active,
				  },
			input_country: this.value
				? this.value.country
					? {
							id: this.value.country.id || 0,
							name: this.value.country.name || "",
							code: this.value.country.code,
							is_active: this.value.country.is_active,
					  }
					: {
							id: this.value.country?.id || 0,
							name: this.value.country?.name || "",
							code: this.value.country?.code,
							is_active: this.value.country?.is_active,
					  }
				: {
						id: this.value.country.id || 0,
						name: this.value.country.name || "",
						code: this.value.country.code,
						is_active: this.value.country.is_active,
				  },
			inputs: {
				name: "",
			},
			// statusLists: [
			//     {id: '', value: "Choose One",},
			//     {id: 'active', value: "Active",},
			//     {id: 'inactive', value: "Inactive",},
			//     {id: 'invited', value: "Invite",},
			// ],
			// genderLists: [
			//     {id: 'male', value: "Male"},
			//     {id: 'female', value: "Female"},
			//     {id: 'other', value: "Other"},
			// ],
			modalId: this.formId,
			modalTitle: this.$t("add"),
		};
	},
	created() {
		if (this.selectedUrl) {
			this.modalTitle = this.$t("edit");
			this.preloader = true;
		}
	},
	methods: {
		submit() {
			this.save(this.inputs);
		},
		afterSuccess(response) {
			this.$toastr.s(response.data.message);
			this.$hub.$emit("reload-" + this.tableId);
		},

		afterSuccessFromGetEditData(response) {
			if (response.data.phone) this.phone = response.data.phone;
			this.inputs = response.data;
			this.preloader = false;
		},
		setParentValue(data) {
			this.inputs.district_id = this.inputs.district_id;
			if (data && data.hasOwnProperty("id")) {
				this.inputs.district_id = data.id;
			}
		},
		resetDistrict() {
			this.input_district = {
				country_id: undefined,
				province_id: undefined,
				city_id: undefined,
				code: "",
				name: "",
				is_active: "",
				district: {
					id: undefined,
					code: "",
					name: "",
					is_active: "",
				},
			};
		},
		resetCity() {
			this.input_city = {
				country_id: undefined,
				province_id: undefined,
				city_id: undefined,
				code: "",
				name: "",
				is_active: "",
				city: {
					id: undefined,
					code: "",
					name: "",
					is_active: "",
				},
			};
		},
		resetProvince() {
			this.input_province = {
				province_id: undefined,
				code: "",
				name: "",
				is_active: "",
				province: {
					id: undefined,
					code: "",
					name: "",
					is_active: "",
				},
			};
		},
		setCityValue(data) {
			this.inputs.city_id = this.inputs.city_id;
			if (data && data.hasOwnProperty("id")) {
				this.inputs.city_id = data.id;
				this.resetDistrict();
			}
		},
		setProvinceValue(data) {
			this.inputs.province_id = this.inputs.province_id;
			if (data && data.hasOwnProperty("id")) {
				this.inputs.province_id = data.id;
				this.resetCity();
			}
		},
		setCountryValue(data) {
			this.inputs.country_id = this.inputs.country_id;
			if (data && data.hasOwnProperty("id")) {
				this.inputs.country_id = data.id;
				this.resetProvince();
			}
		},
	},
};
</script>
